export default __webpack_public_path__ + "1540eefb59e9c8117b946d0c7f0fdc63.svg";